import type { ReactNode } from 'react'
import { cx } from '../../cx'
import styles from './FeatureCard.module.css'

export interface FeatureCardProps {
  icon: ReactNode
  title: ReactNode
  description: ReactNode
  /** Sekcja „Bezpieczeństwo" na landingu jest ciemna (spec 07 §4). */
  tone?: 'light' | 'dark'
  /** Plakietka przy tytule — „WKRÓTCE” przy zapowiedzi (fala 9, grupa 167; D107). */
  badge?: ReactNode
  className?: string
}

export function FeatureCard({
  icon,
  title,
  description,
  tone = 'light',
  badge,
  className,
}: FeatureCardProps) {
  return (
    <div className={cx(styles.card, tone === 'dark' && styles.onDark, className)}>
      <span className={styles.iconWrap} aria-hidden="true">
        {icon}
      </span>
      <h3 className={styles.title}>
        {title}
        {badge === undefined ? null : <span className={styles.badge}>{badge}</span>}
      </h3>
      <p className={styles.description}>{description}</p>
    </div>
  )
}
